import React, { useEffect, useState, useTransition } from "react";
import styled from "@emotion/styled";

import Button from "@components/Button";
import { css } from "@emotion/react";
import JoinRemaxForm from "./form";
import { useWidth } from "custom-hooks/use-width.hook";
import useStatistics from "custom-hooks/use-statistics.hook";
import { useTranslations } from "next-intl";

function Statistic() {
  const translation = useTranslations("join.statistic");
  const translationStatsLabel = useTranslations("join.statistic.statsLabel");
  const translationWhyBeAgent = useTranslations("join.statistic.whyBeAgent");
  const statisticDataItems_ = [
    { title: "1973", description: translationStatsLabel("founded") },
    { title: "544", description: translationStatsLabel("agents") },
    { title: "39", description: translationStatsLabel("offices") },
    {
      title: `24 ${translationStatsLabel("thousand")}`,
      description: translationStatsLabel("properties"),
    },
    {
      title: `+145 ${translationStatsLabel("thousand")}`,
      description: translationStatsLabel("globalAgents"),
    },
  ];

  const [items, setItems] = useState<
    {
      title: string;
      description: string;
    }[]
  >(statisticDataItems_);

  const width = useWidth();
  const { data: statsResponse, isLoading } = useStatistics();
  useEffect(() => {
    if (statsResponse?.data) {
      statisticDataItems_[1].title = statsResponse.data.agents_count.toString();
      statisticDataItems_[2].title =
        statsResponse.data.agencies_count.toString();
      setItems(statisticDataItems_);
    }
  }, [statsResponse]);

  return (
    <Wrapper>
      <StatisticContainer className="container">
        <StatisticContent>
          <StatisticTitle>
            {translation.rich("title", {
              red: (chunks) => <StatisticTitleRed>{chunks}</StatisticTitleRed>,
              light: (chunks) => (
                <StatisticTitleLight>{chunks}</StatisticTitleLight>
              ),
            })}
            {!["xs", "sm"].includes(width) && (
              // <JoinRemaxForm>

              <StatisticButton
                component="a"
                href="https://reclutamiento.remaxrd.com/#Formulario"
                target="_blank"
                rel="noopener noreferrer"
              >
                {translation("joinFamily")}
              </StatisticButton>
              // </JoinRemaxForm>
            )}
          </StatisticTitle>

          <StatisticSubContainer>
            <StatisticSubtitle>
              {translationWhyBeAgent("title")}
            </StatisticSubtitle>
            <StatisticText>{translationWhyBeAgent("benefits")}</StatisticText>
            <StatisticText>{translationWhyBeAgent("info")}</StatisticText>
          </StatisticSubContainer>
          <StatisticData>
            {items.map((item, index) => (
              <StatisticDataItem key={index}>
                <StatisticDataTitle>{item.title}</StatisticDataTitle>
                <StatisticDataDescription>
                  {item.description}
                </StatisticDataDescription>
              </StatisticDataItem>
            ))}
          </StatisticData>
          {["xs", "sm"].includes(width) && (
            // <JoinRemaxForm>
            <StatisticButton
              component="a"
              href="https://reclutamiento.remaxrd.com/#Formulario"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginTop: 30 }}
            >
              {translation("joinFamily")}
            </StatisticButton>
            // </JoinRemaxForm>
          )}
        </StatisticContent>

        <StatisticBackground>
          <Image
            src="/images/image-optimize/agent-remax-join-franchise.webp"
            alt="Buscando agente inmobiliario remax RD"
          />
        </StatisticBackground>
      </StatisticContainer>
    </Wrapper>
  );
}

const sharedCss = css`
  margin-left: 6%;
  @media screen and (max-width: 767px) {
    margin-left: 0;
  }
`;

const Wrapper = styled.section`
  background-color: var(--color-brand-cream-primary);
  padding: 110px 0 0;
  margin-bottom: -5px;
  @media screen and (max-width: 1299px) {
    overflow: hidden;
  }
  @media screen and (max-width: 450px) {
    padding: 100px 0 0;
  }
`;

const StatisticContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 1299px) {
    position: relative;
    padding-bottom: 140px;
  }
  @media screen and (max-width: 767px) {
    padding-bottom: 2rem;
  }
`;

const StatisticContent = styled.section`
  width: calc(100% - 534px);
  @media screen and (max-width: 1299px) {
    width: calc(100% - 234px);
  }
  @media screen and (max-width: 991px) {
    width: 100%;
  }
`;

const StatisticTitle = styled.h2`
  ${sharedCss}
  font-size: 3.313rem;
  font-weight: 500;
  text-align: left;
  max-width: 505px;
  margin-left: 60px;
  text-transform: none;
  margin-bottom: -10px;
  line-height: 30px;
  color: var(--color-brand-blue-main);
  @media screen and (max-width: 767px) {
    font-size: 2.313rem;
    text-align: center;
    margin: 0 auto;
  }
`;

const StatisticTitleRed = styled.span`
  font-size: 2.188rem;
  font-weight: 700;
  color: var(--color-brand-red-main);
  margin-top: 10px;
  display: block;
  width: 100%;
  text-align: center;
  @media screen and (max-width: 767px) {
    font-size: 1.688rem;
    text-align: center;
    margin-left: 0;
  }
`;

const StatisticTitleLight = styled.span`
  font-size: 1.938rem;
  font-weight: 300;
  display: block;
  width: 100%;
  text-align: center;
  @media screen and (max-width: 767px) {
    font-size: 1.438rem;
    text-align: center;
    margin-left: 0;
    font-weight: 400;
  }
`;

const StatisticBackground = styled.div`
  max-width: 634px;
  align-self: flex-end;
  @media screen and (max-width: 1299px) {
    position: absolute;
    right: -15%;
    bottom: 0;
  }
  @media screen and (max-width: 1200px) {
    position: absolute;
    right: -30%;
    bottom: 0;
  }
  @media screen and (max-width: 991px) {
    display: none;
  }
`;

const Image = styled.img`
  width: 100%;
  border-style: none;
`;

const StatisticButton = styled(Button)`
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
  display: block;
  font-weight: 700;
  text-decoration: none;
  border-radius: 15px;
  @media screen and (max-width: 767px) {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
`;

const StatisticSubtitle = styled.h3`
  ${sharedCss}
  margin-top: 94px;
  font-size: 1.438rem;
  font-weight: 700;
  margin-bottom: 17px;
  color: var(--color-brand-blue-main);
  @media screen and (max-width: 450px) {
    margin-top: 50px;
  }
`;

const StatisticSubContainer = styled.div`
  width: 90%;
  margin: 0 auto;

  @media screen and (max-width: 767px) {
    * {
      text-align: center;
    }
  }
`;

const StatisticText = styled.p`
  ${sharedCss}
  font-size: 0.938rem;
  font-weight: 500;
  color: #99999b;
  margin-bottom: 21px;
  max-width: 625px;
`;

const StatisticData = styled.div`
  margin-top: 65px;
  display: flex;
  justify-content: space-between;
  max-width: 750px;
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
    justify-content: center;
  }
  @media screen and (max-width: 700px) {
    flex-wrap: wrap;
    justify-content: space-around;
  }
`;

const StatisticDataItem = styled.div`
  max-width: 113px;
  @media screen and (max-width: 767px) {
    margin: 15px;
  }
  @media screen and (max-width: 575px) {
    max-width: 140px;
    * {
      text-align: center;
    }
  }
  @media screen and (max-width: 450px) {
    width: 50%;
    margin: 15px 0;
    padding: 0px;
  }
`;

const StatisticDataTitle = styled.span`
  font-size: 1.678rem;
  font-weight: 700;
  color: var(--color-brand-blue-secondary);
  margin-bottom: 4px;
  display: block;
  white-space: nowrap;
  text-align: center;
  @media screen and (max-width: 700px) {
    font-size: 35px;
  }
  @media screen and (max-width: 575px) {
    max-width: 140px;
    font-size: 26px;
  }
  @media screen and (max-width: 450px) {
    text-align: left;
  }
`;

const StatisticDataDescription = styled.span`
  font-size: 0.865rem;
  font-weight: 700;
  color: var(--color-brand-grey-quaternary);
  display: block;
  text-align: center;
  @media screen and (max-width: 450px) {
    text-align: left;
  }
`;

export default Statistic;
